
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/california-claimants",
      function () {
        return require("private-next-pages/california-claimants.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/california-claimants"])
      });
    }
  